var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.17 8.677a1.5 1.5 0 0 1 1.646.329l4.178 4.178a1.5 1.5 0 0 1 0 2.132L19.53 26.78A.75.75 0 0 1 19 27h-4.5a1.5 1.5 0 0 1-1.5-1.5v-4.19M25.17 8.677a1.5 1.5 0 0 0-.486.329l.487-.33ZM14.5 21.31V25.5h4.19l11.25-11.25-.005-.004-4.185-4.185-.004.004L14.5 21.31Z",
    fill: "#3D4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 26.25a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 0 1.5H19a.75.75 0 0 1-.75-.75ZM22.22 11.47a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06Z",
    fill: "#3D4043"
  })));
};
export default SvgPen;